import { render } from "./Master.vue?vue&type=template&id=6821ff27"
import script from "./Master.vue?vue&type=script&lang=js"
export * from "./Master.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tis-live/frontend/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__